import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Plus, Search } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Input } from "../components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DashboardPage = () => {
  const { user, subscriptionStatus, getAuthHeaders, canCreateProjects } = useAuth();
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [busca, setBusca] = useState("");

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const response = await axios.get(`${API}/cases`, { headers: getAuthHeaders() });
        setCases(response.data || []);
      } catch {
        toast.error("Erro ao carregar projetos");
      }
    };
    fetchCases();
  }, [getAuthHeaders]);

  const handleCreate = async () => {
    if (!canCreateProjects()) {
      navigate("/regularizacao");
      return;
    }
    try {
      const response = await axios.post(`${API}/cases`, { titulo: titulo || "Novo caso técnico" }, { headers: getAuthHeaders() });
      navigate(`/case/${response.data.id}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao criar projeto");
    }
  };

  const filteredCases = cases.filter((item) => item.titulo?.toLowerCase().includes(busca.toLowerCase()));

  return (
    <div className="min-h-screen bg-[#F5F2EB] p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-serif text-3xl">Painel Técnico</h1>
            <p className="text-[#718096] mt-1">Olá, {user?.name}</p>
          </div>
          <Badge className={subscriptionStatus?.status === "active" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}>
            {subscriptionStatus?.status === "active" ? "Ativo" : "Inativo"}
          </Badge>
        </div>

        {!canCreateProjects() && (
          <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            Modo visualização: seu acesso encontra-se inativo. Você ainda pode visualizar e exportar casos existentes.
          </div>
        )}

        <Card className="mb-6">
          <CardHeader><CardTitle>Novo Projeto</CardTitle></CardHeader>
          <CardContent className="flex flex-col md:flex-row gap-3">
            <Input value={titulo} onChange={(e) => setTitulo(e.target.value)} placeholder="Título do novo caso" />
            <Button onClick={handleCreate}><Plus size={18} className="mr-2" /> Criar projeto</Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader><CardTitle>Projetos</CardTitle></CardHeader>
          <CardContent>
            <div className="relative mb-4">
              <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#718096]" />
              <Input className="pl-9" value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="Buscar projeto" />
            </div>
            <div className="space-y-3">
              {filteredCases.map((item) => (
                <button key={item.id} onClick={() => navigate(`/case/${item.id}`)} className="w-full rounded-lg border bg-white p-4 text-left hover:border-[#0F4C5C]">
                  <div className="flex items-center justify-between gap-4">
                    <div>
                      <p className="font-medium">{item.titulo}</p>
                      <p className="text-sm text-[#718096]">Etapa atual: {item.etapa_atual}</p>
                    </div>
                    {!canCreateProjects() && <Badge className="bg-amber-100 text-amber-700">Somente leitura</Badge>}
                  </div>
                </button>
              ))}
              {filteredCases.length === 0 && <p className="text-sm text-[#718096]">Nenhum projeto encontrado.</p>}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default DashboardPage;
